import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TagInputModule } from 'ngx-chips';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DomainWhitelistService } from '../../../core/routing/services/users/domain-whitelist.service';
import { FormControl } from '@angular/forms';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { StoresConstant } from '../../../core/routing/services/stores_api/constants/stores.constant';
import { ActiveUserConstants } from '../../../core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { RetailStoreConstants } from '../../../core/routing/services/retail_api/constants/retailHq.constants';
import { usersDomainConstants } from '../../../core/routing/services/users/constants/users-domain.constant';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-domain-whitelist',
  templateUrl: './domain-whitelist.component.html',
  styleUrls: ['./domain-whitelist.component.scss']
})
export class DomainWhitelistComponent implements OnInit {
  isAlldevicesSelected: boolean;
  isLoading = false;
  isDomainListTableEmpty: boolean = false;
  globConst = GlobalConstants;
  paginationCount: number;
  totalPages: number;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  isAscendingSort = false;
  sortQueue = {};
  searchClose: boolean;
  loadFlag: string;
  sortType: string;
  createdTime = usersDomainConstants.SORTBY_CRD_TIME;
  email = usersDomainConstants.EMAIL_SORT;
  searchTag = RetailStoreConstants.SEARCH_BY;
  openModalPopup = false;
  domainList: any = [];
  maxSize = 5;
  splitPattern = new RegExp('[\,\;]');
  isAdded = true;
  domainMessage: string;
  page: number;
  tableSize: number;
  showFrom: number;
  showTo: number;
  searchData: string;
  displayDomainWhiteList = [];
  allDomainData = [];
  isMasterSel: boolean;
  isAllSelectedData = new Map();
  isDisabled = true;
  selectedDomainList = [];
  searchPlaceholder: string;
  @ViewChild('emailDomain') domainNameSort: ElementRef;
  @ViewChild('createdTime') createdTimeSort: ElementRef;
  isInputFocus: boolean;
  openDeleteModalPopup: boolean;
  isremoved: boolean;
  removeMessage: string;
  singleDelete: string;
  removedSuccessMessage: string;
  removeSingleDomainTitle: string;
  removeMultipleDomainTitle: string;
  removeTitle: string;
  @ViewChild('searchValue') animateThis: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private googleAnalyticsService: GoogleAnalyticsService, private domainWhiteListService: DomainWhitelistService) {
    TagInputModule.withDefaults({
      tagInput: {
        secondaryPlaceholder: $localize`:@@domain-whitelist.data-header.secondary-placeholder:Enter all email domains to auto-approve for IPOS Central.`,
      }
    });
  }

  ngOnInit(): void {
    this.page = 1;
    this.isMasterSel = false;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.sortType = 'desc';
    this.sortQueue[RetailStoreConstants.SORT_BY] = this.createdTime;
    this.sortQueue[RetailStoreConstants.SORT_TYPES] = this.sortType;
    this.isInputFocus = false;
    this.openDeleteModalPopup = false;
    this.isremoved = true;
    this.singleDelete = '';
    this.removedSuccessMessage = '';
    this.searchPlaceholder = $localize`:@@domain-whitelist.data-header.search-name:Search...`;
    this.tableSize = 10;
    this.searchData = '';
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.removeSingleDomainTitle = $localize`:@@domain-whitelist.data-header.remove-single-domain:Remove Domain`;
    this.removeMultipleDomainTitle = $localize`:@@domain-whitelist.data-header.remove-multiple-domain:Remove Domains`;
    this.getFilterSearchData();
  }
  public validators = [this.containWithDot];

  openCreateDomainModal() {
    this.isAdded = true;
    this.domainList = [];
    this.openModalPopup = !this.openModalPopup;
    setTimeout(() => {
      document.getElementsByTagName('form')[0]
        .setAttribute('autocomplete', 'off');
    }, 300);
  }

  CloseDomainModal() {
    this.openModalPopup = false;
  }
  submitDomainList() {
    const newDomains = this.domainList.map(function (item) {
      return item.value
    })
    const userDomainContent = {
      "emailDomains": newDomains
    };
    this.domainMessage = this.domainList.length === 1 ? '"' + this.domainList[0].value + '"' : this.domainList.length + " Domains";
    this.domainWhiteListService.addNewDomainList(JSON.stringify(userDomainContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(domainResponse => {
        this.isAdded = false;
        this.getAllDomainWhiteListData();
        this.searchData = '';
        this.isMasterSel = false;
        this.isDisabled = true;
      },
      
        error => {
          this.isAdded = false;
        }
      );

  }
  onPaste(event) {
  }
  onTableDataChange(event) {
    this.page = event;
    if (this.isAlldevicesSelected) {
      this.isMasterSel = true;
    }
    this.getAllDomainWhiteListData(this.filterString);
  }
  getAllDomainWhiteListData(filterString?: string) {
    this.domainWhiteListService.getDomainListRecord(this.page, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(domainListResponse => {
        this.allDomainData = domainListResponse.whitelistdomains;
        this.paginationCount = (domainListResponse.paginationContext.totalItems);
        this.totalPages = (domainListResponse.paginationContext.totalPages);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.allDomainData.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        }
        this.displayDomainWhiteList = [];
        this.allDomainData.forEach(ele => {
          ele.isSelected = this.isMasterSel;
          this.displayDomainWhiteList.push(ele);
        });
        this.isDomainListTableEmpty = (this.displayDomainWhiteList?.length === 0) || false;
      },error => {
        this.isDomainListTableEmpty = true;
      });
  }
  searchEmailDomain() {
    this.animateThis.nativeElement.blur();
    if (!this.searchData) {
      return;
    }
    this.domainWhiteListService.searchEmailDomains(this.searchData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(domainResponse => {
        this.allDomainData = domainResponse.whitelistdomains;
        this.showFrom = this.page = 1;
        this.showTo = 10;
        this.displayDomainWhiteList = [];
        this.allDomainData.forEach(ele => {
          ele.isSelected = false;
          this.displayDomainWhiteList.push(ele);
        });
        this.isMasterSel = false;
      });
  }
  clearSearch(val: string) {
    if(val?.length === 0 && this.searchClose){
      this.searchClose = false;
      this.searchQueue = {};
      this.getFilterSearchData();
      this.searchData = ActiveUserConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
    }
  }
  isAllSelected(data) {
    if (this.isAllSelectedData.has(data.emailDomain)) {
      this.isAllSelectedData.delete(data.emailDomain);
    } else {
      this.isAllSelectedData.set(data.emailDomain, data);
    }
    const isAllChecked = this.displayDomainWhiteList.every((item: any) => item.isSelected === true);
    this.isMasterSel = isAllChecked ? true : false;
    this.getSelecetdDomainList();

  }
  checkUncheckAll(event) {
    if (event) {
      this.domainWhiteListService.getAllData(this.filterString)
        .subscribe(res => {
          res.whitelistdomains.forEach(value => {
            this.isAllSelectedData.set(value.emailDomain, value);
          });
          this.getSelecetdDomainList();

        });
    } else {
      this.isAllSelectedData.clear();
      this.getSelecetdDomainList();
    }
    this.isAlldevicesSelected = this.isMasterSel;
    for (var i = 0; i < this.displayDomainWhiteList.length; i++) {
      this.displayDomainWhiteList[i].isSelected = this.isMasterSel;
    }
  }
  getSelecetdDomainList() {
    this.selectedDomainList = Array.from(this.isAllSelectedData.values());
    
    this.isMasterSel = this.isAllSelectedData.size === this.paginationCount;
    this.isDisabled = !(this.selectedDomainList.length > 0);
  }

  removeAllSelectedDomain() {
    if (this.selectedDomainList.length > 0) {
      this.openDeleteModalPopup = !this.openDeleteModalPopup;
      this.isremoved = true;
      if (this.selectedDomainList.length === 1) {
        this.removeMessage = this.selectedDomainList[0].emailDomain;
        this.removedSuccessMessage = '"' + this.selectedDomainList[0].emailDomain + '"';
        this.removeTitle = this.removeSingleDomainTitle;
      } else {
        this.removeMessage = this.selectedDomainList.length + " Domains";
        this.removedSuccessMessage = this.removeMessage;
        this.removeTitle = this.removeMultipleDomainTitle;
      }
    }
  }
  removeItem(item) {
    this.openDeleteModalPopup = !this.openDeleteModalPopup;
    this.isremoved = true;
    this.removeMessage = item.emailDomain;
    this.removedSuccessMessage = '"' + item.emailDomain + '"';
    this.singleDelete = item.emailDomain;
    this.removeTitle = this.removeSingleDomainTitle;
  }
  removeEmailDomainList(removeValues) {
    this.domainWhiteListService.deleteEmailDomainList(removeValues)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(deleteDomainResponse => {
        this.getAllDomainWhiteListData();
        this.searchData = '';
        this.isMasterSel = false;
        this.isremoved = false;
        this.singleDelete = '';
        this.isDisabled = true;
      });
  }
  getDomainListSortByDomain(sortby, element) {
    this.getAllEmailDomianBySort(sortby, this.domainNameSort.nativeElement.getAttribute('data-order'), element)
  }

  getAllEmailDomianBySort(sortby: string, sortedElement, element) {
    this.domainWhiteListService.getEmailDomainWhiteListSortBy(sortby, sortedElement)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(domainListResponse => {
        this.allDomainData = domainListResponse.whitelistdomains;
        if (this.allDomainData.length < 10) {
          this.showTo = this.allDomainData.length;
        } else {
          this.showTo = Math.min(this.page * this.tableSize);
        }
        this.displayDomainWhiteList = [];
        this.allDomainData.forEach(ele => {
          ele.isSelected = false;
          this.displayDomainWhiteList.push(ele);
        });
        this.isMasterSel = false;
      });
    if (sortedElement === GlobalConstants.DESC_SORT) {
      element.nativeElement.setAttribute('data-order', GlobalConstants.ASC_SORT);
    } else {
      element.nativeElement.setAttribute('data-order', GlobalConstants.DESC_SORT);
    }
  }
  getDomainListSortByCreateTime(sortby, element) {
    this.getAllEmailDomianBySort(sortby, this.createdTimeSort.nativeElement.getAttribute('data-order'), element)
  }
  onFocusInput(event) {
    this.isInputFocus = true;
  }
  onBlurInput(event) {
    this.isInputFocus = false;
  }
  removeDomainList() {
    if (this.singleDelete == '') {
      const removingList = this.selectedDomainList.map(function (item) {
        return item.emailDomain
      });
      const romvingStringValues = removingList.join(',');
      this.removeEmailDomainList(romvingStringValues);
    } else {
      this.removeEmailDomainList(this.singleDelete);
    }
  }
  CloseRemoveDomainModal() {
    this.openDeleteModalPopup = false;
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllDomainWhiteListData(this.filterString);
    } else {
      this.getAllDomainWhiteListData();
    }
  }

  searchDomainWishlist(searchData) {
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = ActiveUserConstants.NAME_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchQueue[this.searchTag] = searchData;
      this.getFilterSearchData();
    } else {
      this.getAllDomainWhiteListData();
      this.page = 1;
    }
  }

  searchtheDomainsonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchDomainWishlist(searchData);
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = ActiveUserConstants.EMPTY_VALUE;
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? RetailStoreConstants.ASCENDING_ORDER :
      RetailStoreConstants.DESCENDING_ORDER;
    this.sortQueue[ActiveUserConstants.SORT_BY] = tempval;
    this.sortQueue[ActiveUserConstants.SORT_TYPE] = sortOrder;
    this.getFilterSearchData();
  }

  sort(sortKey: string) {
    switch (sortKey) {
      case (usersDomainConstants.EMAIL_SORT):
        this.sortingTableWithAscandDesc(usersDomainConstants.EMAIL_SORT);
        break;
      case (usersDomainConstants.SORTBY_CRD_TIME):
        this.sortingTableWithAscandDesc(usersDomainConstants.SORTBY_CRD_TIME);
        break;
      default: {
      }
    }
  }
  private containWithDot(control: FormControl) {
    const domainValidationCondition = GlobalConstants.DOMAIN_PATTERN_VALIDATION;
    if (domainValidationCondition.test(control.value)) {
      return null;
    }

    return { status: true };
  }
}
